import { IHRBMicroAppsConfig } from '../interfaces/hrblock-micro-ui-config-interface';
import { environment  } from '../../../environments/environment'
/**
 * Config for maintaining the name and path of
 * the micro apps
 */
export const microApps: IHRBMicroAppsConfig = {
    // NOTE: Name of the micro app should be the customElementTag,
    // defined in the Micro App's Module
    'orp-micro-order-summary': {
        name: 'orp-micro-order-summary',
        path: `${environment.microUiBasePathOrderSummary}/orp-micro-order-summary.js`,
        cssPath: `${environment.microUiBasePathOrderSummary}/styles.css`,
        loaded: false
    },
    'orp-micro-product-details': {
        name: 'orp-micro-product-details',
        path: `${environment.microUiBasePathProductDetails}/orp-micro-product-details.js`,
        cssPath: `${environment.microUiBasePathProductDetails}/styles.css`,
        loaded: false
    },
    'orp-micro-apply-discount': {
        name: 'orp-micro-apply-discount',
        path: `${environment.microUiBasePathCoupon}/orp-micro-apply-discount.js`,
        cssPath: `${environment.microUiBasePathCoupon}/styles.css`,
        loaded: false
    },
    'orp-micro-billing-and-payment': {
        name: 'orp-micro-billing-and-payment',
        path: `${environment.microUiBasePathBilling}/orp-micro-billing-and-payment.js`,
        cssPath: `${environment.microUiBasePathBilling}/styles.css`,
        loaded: false
    },
    'orp-micro-order-confirmation': {
        name: 'orp-micro-order-confirmation',
        path: `${environment.microUiBasePathOrderConfirmation}/orp-micro-order-confirmation.js`,
        cssPath: `${environment.microUiBasePathOrderConfirmation}/styles.css`,
        loaded: false
    }
};
